<div class="calendar-container max-w-6xl mx-auto p-4">
  <h2 class="text-2xl font-bold mb-4">Calendar with Reservation Ribbons</h2>

  @for (month of calendarData.months; track trackByMonth($index, month)) {
    <div class="calendar-month mb-8">
      <!-- Month Header -->
      <div class="month-header mb-4 text-center">
        <h3 class="text-xl font-semibold text-gray-800">{{ month.monthName }} {{ month.monthYear }}</h3>
      </div>

      <!-- Day Labels Header -->
      <div class="calendar-day-labels grid grid-cols-[repeat(7,1fr)] gap-0">
        @for (label of dayLabels; track $index) {
          <div class="day-label text-center text-sm font-medium text-gray-600 py-2 border-b-2 border-gray-200">
            {{ label }}
          </div>
        }
      </div>

      <!-- Calendar Grid with Ribbons -->
      <div class="calendar-grid relative">
        @for (week of month.weeks; track trackByWeek($index)) {
          <!-- Week Row -->
          <div class="calendar-week-row relative h-24">
            <!-- Days Background -->
            <div class="absolute inset-0 grid grid-cols-[repeat(14,1fr)] gap-0">
              @for (day of week.days; track trackByDay($index, day)) {
                <div
                  class="calendar-day col-span-2 border-l border-b border-gray-200 p-1"
                  [class.bg-gray-50]="!day.isCurrentMonth"
                  [class.bg-blue-50]="day.isToday">
                  <span class="text-xs" [class.text-gray-400]="!day.isCurrentMonth">
                    {{ day.dayNumber }}
                  </span>
                </div>
              }
            </div>

            <!-- Reservation Ribbons -->
            <div class="absolute inset-0 grid grid-cols-[repeat(14,1fr)] gap-0 pointer-events-none mt-6">
              @for (ribbon of getWeekRibbons(week); track ribbon.reservation.id) {
                <div
                  class="pointer-events-auto cursor-pointer hover:brightness-110 hover:z-10 transition-all"
                  [style.grid-column-start]="ribbon.startColumn"
                  [style.grid-column-end]="ribbon.endColumn"
                  [matTooltip]="getDebugInfo(ribbon)"
                  matTooltipPosition="above">
                  <ui-calendar-ribbon
                    [label]="ribbon.reservation.identifier"
                    [channel]="ribbon.reservation.platform"
                    [starts]="ribbon.startsThisWeek"
                    [ends]="ribbon.endsThisWeek"
                    [blocked]="ribbon.blocked">
                  </ui-calendar-ribbon>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Legend and Examples -->
  <div class="mt-8 space-y-4">
    <!-- Platform Legend -->
    <div class="p-4 bg-gray-50 rounded-lg">
      <h4 class="font-semibold mb-2">Reservation Platforms:</h4>
      <div class="flex flex-wrap gap-4">
        @for (platform of platforms; track platform.name) {
          <div class="flex items-center gap-2">
            <ui-calendar-ribbon [label]="''" [channel]="platform.name" [starts]="true" [ends]="true" class="w-20">
            </ui-calendar-ribbon>
            <span class="text-sm">{{ platform.label }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Examples Description -->
    <div class="p-4 bg-blue-50 rounded-lg">
      <h4 class="font-semibold mb-2">Reservation Examples:</h4>
      <ul class="text-sm space-y-1">
        <li><strong>MON-START:</strong> Starts on Monday</li>
        <li><strong>SUN-START:</strong> Starts on Sunday</li>
        <li><strong>MULTI-WEEK:</strong> Spans multiple weeks (10 days)</li>
        <li><strong>CROSS-WEEK:</strong> Starts Friday, ends Tuesday next week</li>
        <li><strong>SAME-WEEK:</strong> Starts and ends in the same week</li>
        <li><strong>CHECKOUT & CHECKIN:</strong> Back-to-back reservations (checkout Saturday, checkin Sunday)</li>
      </ul>
    </div>
  </div>
</div>
